module.exports = __webpack_public_path__ + "img/2.8f928c19.png";